// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"Register_pageContent__2OH5E","formWrapper":"Register_formWrapper__319OP","formEmbed":"Register_formEmbed__k33gn","fallbackLink":"Register_fallbackLink__2Gezg"};